import styled from 'styled-components';

export default styled.img`
  max-width: 400px;
  width: 90%;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/BannerImage/BannerImage.js